// extracted by mini-css-extract-plugin
module.exports = {"container":"_4e5f713ae4--container--lPlvk","logo":"_4e5f713ae4--logo--dlbCj","link":"_4e5f713ae4--link--B6rT9","foundation":"_4e5f713ae4--foundation--yp0iL"};